class WaGymLive extends HTMLElement {
  connectedCallback() {
    if (this.started) return;
    this.started=true;
    this.abort=new AbortController();
    this.ready=false;
    this.busy=false;
    this.approval=null;
    this.$=selector=>this.querySelector(selector);
    this.msg=JSON.parse(this.$('[data-messages]').textContent);
    this.settings=JSON.parse(this.$('[data-design-settings]').textContent);
    this.renderer=globalThis.WallanthemGymRenderer;
    this.form=this.$('form');
    this.canvas=this.$('[data-banner]');
    this.ctx=this.canvas.getContext('2d');
    this.dialog=this.$('dialog');
    this.addLabel=this.$('[data-add]').textContent;
    this.templateVersion=this.dataset.templateVersion;
    this.storageKey=`wa-gym-product-${this.dataset.product}-${this.dataset.designId}-v${this.templateVersion}`;
    this.state={designId:this.dataset.designId,templateVersion:this.templateVersion,name:'',motto:this.dataset.defaultMotto};
    try {
      const saved=JSON.parse(localStorage.getItem(this.storageKey));
      if(saved && saved.designId===this.state.designId && saved.templateVersion===this.templateVersion && typeof saved.name==='string' && typeof saved.motto==='string') {
        this.state={...this.state,name:saved.name.slice(0,28),motto:saved.motto.slice(0,36)};
      }
    } catch {}
    for(const key of ['name','motto']) this.$(`[name="${key}"]`).value=this.state[key];
    const listen=(target,name,handler)=>target.addEventListener(name,handler,{signal:this.abort.signal});
    listen(this.form,'input',()=>this.update());
    listen(this.form,'submit',event=>{event.preventDefault();this.review();});
    listen(this.$('[data-zoom]'),'click',()=>this.review());
    for(const selector of ['[data-close]','[data-edit]']) listen(this.$(selector),'click',()=>{if(!this.busy)this.dialog.close();});
    listen(this.dialog,'cancel',event=>{if(this.busy)event.preventDefault();});
    listen(this.$('[data-confirm]'),'change',()=>this.updateCheckout());
    listen(this.$('[data-add]'),'click',()=>this.addToCart());
    listen(this.$('[data-reset]'),'click',()=>{this.form.reset();this.update();});
    listen(this,'pointerdown',event=>{this.pendingControlActivation=!!event.target.closest('button,a,summary,input');});
    listen(this,'click',()=>{this.pendingControlActivation=false;this.syncTypingLayout(this.ownerDocument.activeElement);});
    listen(this,'pointercancel',()=>{this.pendingControlActivation=false;this.syncTypingLayout(this.ownerDocument.activeElement);});
    listen(window,'pointerdown',event=>{if(!this.contains(event.target)){this.pendingControlActivation=false;this.syncTypingLayout(event.target);}});
    listen(this.form,'focusin',event=>this.syncTypingLayout(event.target));
    listen(this.form,'focusout',event=>this.syncTypingLayout(event.relatedTarget));
    listen(window,'pageshow',()=>this.setBusy(false));
    this.update();
    this.initialize();
  }
  disconnectedCallback() { this.abort?.abort();this.started=false; }
  syncTypingLayout(target) {
    if(this.dialog.open){this.classList.remove('is-typing');return;}
    if(target?.matches('input[type="text"]')){this.classList.add('is-typing');return;}
    if(target && !this.contains(target)){this.pendingControlActivation=false;this.classList.remove('is-typing');return;}
    if(this.pendingControlActivation || target && (this.form.contains(target) || target.closest('[data-zoom]')))return;
    this.classList.remove('is-typing');
  }
  async initialize() {
    try {
      if(!this.renderer || !this.dataset.art || !this.dataset.room || !this.renderer.DESIGNS[this.dataset.designId]) throw new Error();
      const sources=JSON.parse(this.$('[data-font-sources]').textContent);
      const specifications=this.renderer.fontsForVersion(this.templateVersion);
      if(!specifications?.length)throw new Error();
      const fonts=await Promise.all(specifications.map(async specification=>{
        const source=sources[specification.asset];
        if(!source)throw new Error();
        const font=new FontFace(specification.family,`url(${source})`,{weight:specification.weight});
        await font.load();
        if(font.status!=='loaded')throw new Error();
        return font;
      }));
      for(const font of fonts)document.fonts.add(font);
      const loadImage=src=>new Promise((resolve,reject)=>{const image=new Image();image.crossOrigin='anonymous';image.onload=()=>resolve(image);image.onerror=reject;image.src=src;});
      [this.art,this.room]=await Promise.all([loadImage(this.dataset.art),loadImage(this.dataset.room)]);
      if(!this.isConnected || this.abort.signal.aborted)return;
      this.ready=true;
      this.$('[data-status]').textContent='';
      this.update();
    } catch { this.ready=false;if(this.isConnected){this.update();this.$('[data-status]').textContent=this.msg.load_error;} }
  }
  values() {
    return {
      designId:this.dataset.designId,
      templateVersion:this.templateVersion,
      name:this.$('[name="name"]').value.normalize('NFKC').trim().toUpperCase().replace(/['’]S$/,'').trim(),
      motto:this.$('[name="motto"]').value.normalize('NFKC').trim().toUpperCase()
    };
  }
  heading() { return `${this.state.name || this.msg.sample_name}’S GYM`; }
  update() {
    const state=this.values();
    if(JSON.stringify(state)!==JSON.stringify(this.state)) {
      this.approval=null;this.$('[data-confirm]').checked=false;this.$('[data-review-status]').textContent='';this.$('[data-cart-link]').hidden=true;
    }
    this.state=state;
    const nameValid=/^[A-ZÀ-ÖØ-Þ0-9 .,'’&-]+$/u.test(state.name) && state.name.length<=28;
    const mottoValid=/^[A-ZÀ-ÖØ-Þ0-9 .,'’&!?:;()+/—–-]+$/u.test(state.motto) && state.motto.length<=36;
    this.$('[name="name"]').setCustomValidity(!state.name?this.msg.required:nameValid?'':this.msg.name_characters);
    this.$('[name="motto"]').setCustomValidity(!state.motto?this.msg.required:mottoValid?'':this.msg.motto_characters);
    this.$('[data-name-count]').textContent=`${this.$('[name="name"]').value.length}/28`;
    this.$('[data-motto-count]').textContent=`${this.$('[name="motto"]').value.length}/36`;
    for(const button of this.querySelectorAll('[data-needs-ready]'))button.disabled=!this.ready || this.busy;
    this.$('[data-review]').disabled=!this.ready || this.busy || this.dataset.available!=='true';
    this.canvas.setAttribute('aria-label',[this.heading(),state.motto,this.msg.scene].join(' — '));
    try { localStorage.setItem(this.storageKey,JSON.stringify(state)); } catch {}
    if(this.ready)this.drawScene(this.ctx);
    else {this.ctx.fillStyle='#161715';this.ctx.fillRect(0,0,this.canvas.width,this.canvas.height);}
    this.updateCheckout();
  }
  drawScene(context) {
    this.renderer.drawScene(context,{configuration:this.state,art:this.art,room:this.room,layout:this.settings.layout,roomPlacement:this.settings.roomPlacement});
  }
  updateCheckout() { this.$('[data-add]').disabled=this.busy || !this.ready || !this.$('[data-confirm]').checked || this.dataset.available!=='true'; }
  setBusy(value) {
    this.busy=value;this.form.inert=value;this.dialog.setAttribute('aria-busy',String(value));
    for(const selector of ['[data-close]','[data-edit]','[data-confirm]'])this.$(selector).disabled=value;
    this.$('[data-add]').textContent=value?this.msg.adding:this.addLabel;this.updateCheckout();
  }
  review() {
    if(this.busy || !this.ready || !this.form.reportValidity())return;
    const canvas=this.$('[data-large]');this.drawScene(canvas.getContext('2d'));canvas.setAttribute('aria-label',this.canvas.getAttribute('aria-label'));
    this.$('[data-summary]').textContent=[this.heading(),this.state.motto].join(' · ');
    this.updateCheckout();this.dialog.showModal();this.pendingControlActivation=false;this.classList.remove('is-typing');
  }
  prepareApproval() {
    const fingerprint=JSON.stringify(this.state);
    if(this.approval?.fingerprint===fingerprint)return this.approval;
    const canvas=this.$('[data-large]');this.drawScene(canvas.getContext('2d'));
    const bytes=crypto.getRandomValues(new Uint8Array(32));
    this.approval={fingerprint,token:Array.from(bytes,byte=>byte.toString(16).padStart(2,'0')).join(''),payload:JSON.stringify({configuration:{...this.state},proof_b64:canvas.toDataURL('image/png').split(',')[1],approved:true}),saved:null,cartUncertain:false};
    return this.approval;
  }
  async request(url,options={},timeout=25000) {
    const controller=new AbortController();const abort=()=>controller.abort();this.abort.signal.addEventListener('abort',abort,{once:true});const timer=setTimeout(abort,timeout);
    try{return await fetch(url,{...options,signal:controller.signal});}
    finally{clearTimeout(timer);this.abort.signal.removeEventListener('abort',abort);}
  }
  async saveApproval(approval) {
    if(approval.saved)return approval.saved;
    for(let attempt=0;attempt<2;attempt++) {
      try {
        const response=await this.request(this.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json','X-Submission-Token':approval.token},body:approval.payload,referrerPolicy:'no-referrer'},45000);
        if(!response.ok){const error=new Error(this.msg.save_error);error.retryable=response.status>=500 || response.status===429;throw error;}
        const result=await response.json();
        if(!result.submission_id || !result.configuration || !result.config_url || !result.proof_url)throw new Error(this.msg.save_error);
        const config=result.configuration;
        if(config.designId!==this.state.designId || config.templateVersion!==this.state.templateVersion || config.name!==this.state.name || config.motto!==this.state.motto)throw new Error(this.msg.save_error);
        approval.saved=result;return result;
      } catch(error) {
        if(this.abort.signal.aborted)throw error;
        if(attempt===0 && (error.retryable || error.name==='TypeError' || error.name==='AbortError'))continue;
        throw new Error(this.msg.save_error);
      }
    }
  }
  async cartContains(submissionId) {
    try {
      const response=await this.request(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error();const cart=await response.json();if(!Array.isArray(cart.items))throw new Error();
      return cart.items.some(item=>String(item.variant_id)===this.dataset.variant && item.properties?.['_Wallanthem submission']===submissionId);
    } catch {throw new Error(this.msg.cart_check_error);}
  }
  properties(saved) {
    return {
      [this.msg.property_name]:saved.configuration.name,
      [this.msg.property_motto]:saved.configuration.motto,
      [this.msg.property_design]:this.dataset.designLabel || saved.configuration.designId,
      [this.msg.property_approval]:this.msg.approved,
      '_Wallanthem submission':saved.submission_id,
      '_Configuration':saved.config_url,
      '_Preview':saved.proof_url,
      '_Design ID':saved.configuration.designId,
      '_Template version':saved.configuration.templateVersion
    };
  }
  async addToCart() {
    if(this.busy || !this.ready || this.dataset.available!=='true' || !this.form.reportValidity())return;
    if(!this.$('[data-confirm]').checked){this.$('[data-review-status]').textContent=this.msg.confirmation_required;this.$('[data-confirm]').focus();return;}
    this.setBusy(true);this.$('[data-cart-link]').hidden=true;this.$('[data-review-status]').textContent=this.msg.saving;
    try {
      const approval=this.prepareApproval();const saved=await this.saveApproval(approval);this.$('[data-review-status]').textContent=this.msg.adding;
      if(await this.cartContains(saved.submission_id)){window.location.assign(this.dataset.cartUrl);return;}
      if(approval.cartUncertain)throw new Error(this.msg.cart_uncertain);
      let response;
      try {
        response=await this.request(this.dataset.cartAddUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1,properties:this.properties(saved)}]})});
      } catch {
        approval.cartUncertain=true;
        if(await this.cartContains(saved.submission_id)){window.location.assign(this.dataset.cartUrl);return;}
        throw new Error(this.msg.cart_uncertain);
      }
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(typeof error.description==='string'?error.description:this.msg.cart_error);}
      approval.cartUncertain=true;window.location.assign(this.dataset.cartUrl);
    } catch(error) {
      if(!this.isConnected || this.abort.signal.aborted)return;
      this.$('[data-review-status]').textContent=error.message || this.msg.cart_error;this.$('[data-cart-link]').hidden=false;
    } finally {if(this.isConnected)this.setBusy(false);}
  }
}
if(!customElements.get('wa-gym-live'))customElements.define('wa-gym-live',WaGymLive);
